module.exports = __webpack_public_path__ + "static/media/14.cf7d2076.jpg";